import { FETCH_SERVICE, CLEAR_SERVICE } from '../actions/ServiceAction';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_SERVICE:
      return {
        ...action.payload
      }
    case CLEAR_SERVICE: 
     return {}
    default:
      return {
        ...state
      }
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ServiceReducer.js